import i18next from "i18next";
import { initReactI18next } from "react-i18next/initReactI18next";
import resources from "./resources";
import "./localeSetup";

export default function i18nInit(initLocale) {
  if (!i18next.isInitialized) {
    i18next
      .use(initReactI18next) // passes i18n down to react-i18next
      .init({
        resources,
        lng: initLocale,
        fallbackLng: false,
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
          escapeValue: false, // react already safe from xss
        },
      });
  }

  return i18next;
}
